import styles from "./upcomingLiveGameBannner.module.css"

const bannerStyles = {
    container: `flex flex-col items-center gap-1  max-w-[unset] container relative
                screen-970:w-[400px] screen-970:max-w-[400px]
    `,
    closeIcon: `absolute top-1/2 -translate-y-1/2 -right-[calc(var(--tw-this-width)/2)] cursor-pointer transition-opacity duration-200 z-10 bg-themeShadowColor rounded-full text-white p-1 w-[var(--tw-this-width)] h-[var(--tw-this-width)] [--tw-this-width:33px] flex items-center justify-center`,
    sliderWrapper: `bg-liveGameBackground rounded w-[auto] max-w-[80%] h-[52px] flex items-center gap-1 p-1 ${styles.sliderWrapper}
                    screen-970:max-w-[400px]
    `,
    disabledButton: `opacity-30 cursor-not-allowed`,
    scrollableContent: `flex items-center overflow-x-auto no-scrollbar gap-2`,
    marqueeContainer: `flex items-center`,
    marqueeText: `text-[#61C366] mr-8 uppercase`,
    marqueeWrapper: `bg-upcomingGamesBanner py-1 relative rounded-r`
}

const cardStyles = {
    card: `rounded bg-themeColor w-[165px] px-3 py-1 flex justify-between items-center cursor-pointer`,
    versusImage: `w-[25px] h-[25px] object-contain`,
    teamImage: `w-[30px] h-[30px] object-contain`,
}

export { bannerStyles, cardStyles }